import { useCallback } from "react";
import {
  VIMEO_PROJECTS_LIMIT,
  VIMEO_VIDEO_LIST_LIMIT,
} from "../../config/const";
import { ProgramStore } from "../../stores/ProgramStore";
import { Media } from "../../types";

interface UseLoadVimeoVideoOptionsProps {
  programStore: ProgramStore;
  selectedFolder: {
    label: string;
    value: string;
  };
  medias: Media[];
}
export const useLoadVimeoVideoOptions = ({
  programStore,
  selectedFolder,
  medias,
}: UseLoadVimeoVideoOptionsProps) => {
  const loadVimeoVideoOptions = useCallback(
    async (search: string, loadedOptions: any, { page }: any) => {
      await programStore.fetchMediaList(
        selectedFolder.value,
        page,
        VIMEO_PROJECTS_LIMIT,
        search
      );
      return {
        options: [
          ...programStore.mediaList.map((media: Media) => {
            return {
              label: media.createdAt.toLocaleDateString() + " - " + media.name,
              value: media.externalId,
            };
          }),
        ],
        hasMore: search
          ? false
          : Math.ceil(programStore.mediaListTotal / VIMEO_VIDEO_LIST_LIMIT) >
            page,
        additional: {
          page: page + 1,
        },
      };
    },
    [programStore, selectedFolder.value]
  );

  const getSelectedVideoId: any = useCallback(
    (id: any) => {
      return {
        label: medias.find((media: Media) => {
          let splittedArray = media.uri.split("/");
          if (splittedArray[splittedArray.length - 1] === id) return media;
        })?.name,
        value: id,
      };
    },
    [medias]
  );

  return { loadVimeoVideoOptions, getSelectedVideoId };
};
